var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScissor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 5.6875C3.68944 5.6875 4.375 5.00194 4.375 4.15625C4.375 3.31056 3.68944 2.625 2.84375 2.625C1.99806 2.625 1.3125 3.31056 1.3125 4.15625C1.3125 5.00194 1.99806 5.6875 2.84375 5.6875Z",
    stroke: "#F5A623",
    strokeWidth: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 11.375C3.68944 11.375 4.375 10.6894 4.375 9.84375C4.375 8.99806 3.68944 8.3125 2.84375 8.3125C1.99806 8.3125 1.3125 8.99806 1.3125 9.84375C1.3125 10.6894 1.99806 11.375 2.84375 11.375Z",
    stroke: "#F5A623",
    strokeWidth: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29297 4.78516L3.99219 5.19531L5.00391 5.60547C5.00391 5.60547 5.09852 5.42992 5.19531 5.33203L4.29297 4.78516Z",
    stroke: "#F5A623",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21562 9.14475L12.5782 4.42986C12.5098 4.24666 11.8125 4.10174 10.8282 4.32049C10.0319 4.4974 7.5152 5.11482 6.47613 5.8531C5.62875 6.45494 6.20707 7.43768 5.25004 8.14861C4.54977 8.66814 4.03516 8.7726 4.03516 8.7726L4.21562 9.14475ZM9.41914 7.6083L8.06645 8.38568C8.45555 8.56998 9.85855 9.29541 11.2657 9.37908C11.6736 9.40342 12.086 9.38975 12.3321 9.21502L9.41914 7.6083Z",
    stroke: "#F5A623",
    strokeWidth: 0.88,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.4375C7.48325 7.4375 7.875 7.04575 7.875 6.5625C7.875 6.07925 7.48325 5.6875 7 5.6875C6.51675 5.6875 6.125 6.07925 6.125 6.5625C6.125 7.04575 6.51675 7.4375 7 7.4375Z",
    stroke: "#F5A623",
    strokeWidth: 0.88,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissor);
export default __webpack_public_path__ + "static/media/scissor.f1225071bd9fcd1546f67df26d703129.svg";
export { ForwardRef as ReactComponent };